module.exports = __webpack_public_path__ + "fonts/NespressoLucas-MedItalic.svg?v=b4210d2096c3e8990ac837192944bae0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-MedItalic.svg
// module id = 634
// module chunks = 0